import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import { API_ROOT } from "@/utils/api_root";
import { http } from '@/utils/http';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    auth: {},
    user: null,
    users: {facilitators: {}, hidden: {}},
    cardsAll: {},
    cardsByTag: {},
    cardsByUser: {},
    cardById: {},
    tags: [],
    commentsByCard: {},
    showSignIn: false,
    showSignUp: false,
    showForgetPass: false,
    showWriteMessagePopup: false,
    writeMessageUser: null,
    authLoading: false
  },
  getters: {
    currentUser: state => state.currentUser || {},
    authorized: state => state.currentUser != null,
    isAdmin: (state, getters) => getters.currentUser.role == 'admin',
    auth: state => state.auth,
    users: state => type => state.users[type],
    user: state => id => state.user || {},
    cards: state => (type = 'visible') => state.cardsAll[type] || [],
    cardsByTag: state => (tagId, type = 'visible') => state.cardsByTag[`${tagId}_${type}`] || [],
    cardsByUser: state => (userId, type = 'visible') => state.cardsByUser[`${userId}_${type}`] || [],
    card: state => id => state.cardById[id] || {},
    tags: state => state.tags,
    tag: state => id => state.tags.find(tag => tag.id === id) || {},
    commentsByCard: state => cardId => state.commentsByCard[cardId] || [],
  },
  mutations: {
    auth (state, value) {
      state.auth = value;
    },
    currentUser (state, value) {
      state.currentUser = value;
    },
    user (state, value) {
      console.log('store user mutation', value);
      // Vue.set(state.users, value.id, value);
      state.user = value;
    },
    users (state, {type, value}) {
      console.log('store users mutation', type, value);
      const usersObj = Object.fromEntries(
                          value.map(
                            user =>
                              [user.id, user]
                          )
                        );
      state.users[type] = usersObj;
      // value.forEach(user => Vue.set(state.users, user.id, user));
    },
    card (state, value) {
      console.log('store card mutation', value);
      Vue.set(state.cardById, value.id, value);
    },
    cardsAll (state, {type = 'visible', value}) {
      console.log('store cardsAll mutation', value);
      Vue.set(state.cardsAll, type, value);
      // value.forEach(card => Vue.set(state.cards, card.id, card));
    },
    cardsByUser (state, {userId, type = 'visible', value}) {
      console.log('store cardsByUser mutation', value);
      Vue.set(state.cardsByUser, `${userId}_${type}`, value);
      // value.forEach(card => Vue.set(state.cards, card.id, card));
    },
    cardsByTag (state, {tagId, type = 'visible', value}) {
      console.log('store cardsByTag mutation', tagId, type, value);
      Vue.set(state.cardsByTag, `${tagId}_${type}`, value);
      // value.forEach(card => Vue.set(state.cards, card.id, card));
    },
    tags (state, value) {
      console.log('store tags mutation', value);
      state.tags = value;
    },
    commentsByCard (state, {cardId, value}) {
      Vue.set(state.commentsByCard, cardId, value);
    },
    onShowSignIn (state) {
      state.showSignIn = true;
      state.showSignUp = false;
      state.showForgetPass = false;
    },
    onShowSignUp (state) {
      state.showSignIn = false;
      state.showSignUp = true;
      state.showForgetPass = false;
    },
    onShowForgetPass (state) {
      state.showSignIn = false;
      state.showSignUp = false;
      state.showForgetPass = true;
    },
    onHideSignIn (state) {
      state.showSignIn = false;
    },
    onHideSignUp (state) {
      state.showSignUp = false;
    },
    onHideForgetPass (state) {
      state.showForgetPass = false;
    },
    authLoadingOn (state) {
      state.authLoading = true;
    },
    authLoadingOff (state) {
      state.authLoading = false;
    },
    onShowWriteMessagePopup (state, user) {
      console.log('onShowWriteMessagePopup', user);
      state.writeMessageUser = user;
      state.showWriteMessagePopup = true;
    },
    onHideWriteMessagePopup (state) {
      console.log('onHideWriteMessagePopup');
      state.writeMessageUser = null;
      state.showWriteMessagePopup = false;
    }
  },
  actions: {
    loadCurrentUser: async function({commit, state}) {
      console.log('API_ROOT', API_ROOT);
      console.log('authLoading before if', state.authLoading);
      if (state.authLoading) return;
      commit('authLoadingOn');
      console.log('authLoading after On', state.authLoading);
      const resp = await http.get(`${API_ROOT}/users/current.json`);
      commit('authLoadingOff');
      console.log('authLoading after Off', state.authLoading);
      console.log('store loadCurrentUser response', resp.data);
      commit('currentUser', resp.data);
    },
    loadUsers: async function({commit}, type) {
      const resp = await http.get(`${API_ROOT}/users.json?type=${type}`);
      console.log('store loadUsers reponse', resp.data);
      commit('users', {type: type, value: resp.data});
    },
    loadUser: async function({commit, state}, id) {
      const resp = await http.get(`${API_ROOT}/users/${id}.json`);
      console.log('store loadUser response', resp.data);
      commit('user', resp.data);
    },
    loadCardsAll: async function({commit, state}, type = 'visible') {
      const resp = await http.get(`${API_ROOT}/cards.json?type=${type}`);
      console.log('store loadCardsAll response', resp.data);
      commit('cardsAll', {type: type, value: resp.data});
    },
    loadCardsByUser: async function({commit, state}, {userId, type = 'visible'}) {
      const resp = await http.get(`${API_ROOT}/users/${userId}/cards.json?type=${type}`);
      console.log('store loadCardsByUser response', resp.data);
      commit('cardsByUser', {userId: userId, type: type, value: resp.data});
    },
    loadCardsByTag: async function({commit, state}, {tagId, type = 'visible'}) {
      console.log('store loadCardsByTag tagId type', tagId, type);
      const resp = await http.get(`${API_ROOT}/tags/${tagId}/cards.json?type=${type}`);
      console.log('store loadCardsByTag response', resp.data);
      commit('cardsByTag', {tagId: tagId, type: type, value: resp.data});
    },
    loadCard: async function({commit, state}, id) {
      const resp = await http.get(`${API_ROOT}/cards/${id}.json`);
      console.log('store loadCard response', resp.data);
      commit('card', resp.data);
    },
    loadTags: async function({commit}) {
      const resp = await http.get(`${API_ROOT}/tags.json`);
      console.log('store loadTags reponse', resp.data);
      commit('tags', resp.data);
    },
    loadCommentsByCard: async function({commit, state}, cardId) {
      const resp = await http.get(`${API_ROOT}/cards/${cardId}/comments.json`);
      console.log('store loadCommentsByCard response', resp.data);
      commit('commentsByCard', {cardId: cardId, value: resp.data});
    },
  }
});
